import Action from './enums/RequestHistoryActionType';
import Status from './enums/RequestStatusType';

const STATUS_ACTIONS = [
    Action.WORKUP,
    Action.REWORK,
    Action.PAUSED,
    Action.FINISH,
    Action.DENIED,
    Action.CLOSED,
    Action.SYSTEM_CLOSED,
];

export function lifecycleEvents(history, securityGroups = []) {
    const groups = new Map(securityGroups.map((group) => [Number(group.id), group.name]));
    let previousStatus = null;

    return (Array.isArray(history) ? history : [])
        .filter(
            (point) =>
                point &&
                (point.action === Action.CREATED ||
                    point.action === Action.CHANGE_SECURITY_GROUP ||
                    STATUS_ACTIONS.includes(point.action)),
        )
        .slice()
        .sort((left, right) => Number(left.id) - Number(right.id))
        .map((point) => {
            let title = '';
            switch (point.action) {
                case Action.CREATED:
                    title = 'Создано';
                    previousStatus = Status.WORKUP;
                    break;
                case Action.CHANGE_SECURITY_GROUP: {
                    let meta = null;
                    try {
                        meta = typeof point.meta === 'string' ? JSON.parse(point.meta) : point.meta;
                    } catch (_) {
                        // Older history may have malformed or missing metadata.
                    }
                    const groupId = Number(meta?.securityGroup);
                    title = `Передано в группу: ${groups.get(groupId) || 'группа не указана'}`;
                    break;
                }
                case Action.WORKUP:
                    title = previousStatus === Status.CLOSED ? 'Повторно открыто' : 'Возобновлена обработка';
                    previousStatus = Status.WORKUP;
                    break;
                case Action.REWORK:
                    title = 'На уточнении';
                    previousStatus = Status.REWORK;
                    break;
                case Action.PAUSED:
                    title = 'Приостановлено';
                    previousStatus = Status.PAUSED;
                    break;
                case Action.FINISH:
                    title = 'Выполнено';
                    previousStatus = Status.FINISH;
                    break;
                case Action.DENIED:
                    title = 'Отказано';
                    previousStatus = Status.DENIED;
                    break;
                case Action.CLOSED:
                case Action.SYSTEM_CLOSED:
                    title = 'Закрыто';
                    previousStatus = Status.CLOSED;
                    break;
                default:
                    break;
            }
            return { id: point.id, title, createdAt: point.createdAt };
        });
}

export function lifecycleState(request) {
    const status = request.status;
    const history = (Array.isArray(request.history) ? request.history : [])
        .slice()
        .sort((a, b) => Number(a.id) - Number(b.id));
    const latestCloseIndex = history.map((point) => point.action).lastIndexOf(Action.CLOSED);
    const latestSystemCloseIndex = history.map((point) => point.action).lastIndexOf(Action.SYSTEM_CLOSED);
    const closeIndex = Math.max(latestCloseIndex, latestSystemCloseIndex);
    const beforeClose =
        status === Status.CLOSED ? history.slice(0, closeIndex < 0 ? history.length : closeIndex) : history;
    const latestWorkup = beforeClose.map((point) => point.action).lastIndexOf(Action.WORKUP);
    const previousClose = beforeClose.map((point) => point.action).lastIndexOf(Action.CLOSED);
    const previousSystemClose = beforeClose.map((point) => point.action).lastIndexOf(Action.SYSTEM_CLOSED);
    const previousClosure = Math.max(previousClose, previousSystemClose);
    const currentCycle = beforeClose.slice(latestWorkup + 1);
    const cycleIsKnown =
        history.some((point) => point.action === Action.CREATED) &&
        (previousClosure < 0 || latestWorkup > previousClosure);
    const confirmedSolution =
        cycleIsKnown && currentCycle.some((point) => [Action.FINISH, Action.DENIED].includes(point.action));

    return {
        active:
            status === Status.CLOSED
                ? 'closed'
                : [Status.FINISH, Status.DENIED].includes(status)
                ? 'solution'
                : 'processing',
        processingTitle:
            status === Status.REWORK ? 'На уточнении' : status === Status.PAUSED ? 'Приостановлено' : 'В обработке',
        solutionTitle: status === Status.DENIED ? 'Отказано' : 'Выполнено',
        solutionReached:
            [Status.FINISH, Status.DENIED].includes(status) || (status === Status.CLOSED && confirmedSolution),
        closed: status === Status.CLOSED,
        historyPartial: !history.some((point) => point.action === Action.CREATED),
    };
}
